import styled from 'styled-components';
import Translator from '@/layout/components/helpers/Translator';
import wlv2 from '@/assets/images/wlv2.png';
import { useParams } from 'react-router-dom';

export default function SsoLoginScreen() {
  const { client } = useParams();

  return (
    <Container>
        <img src={wlv2} />
        <h4>Acceso a WorldlexNet mediante directorio activo</h4>
        <a
            href={`https://worldlex.net/saml/login?idp=${client}`}
            className="btn btn-login"
        >
            Acceder con Single Sign-on
        </a>
        <p>Si tiene algún problema de acceso contacte con el gestor de credenciales de su empresa.</p>
    </Container>
  );
}

const Container = styled.div`
    width: 300px;
    margin: 0 auto;
    padding-top: 60px;
    font-size: 14px;
    text-align: center;

    img {
        display: block;
        margin: 0 auto 20px;
        width: 250px;
    }

    .btn-login {
        border-radius: 3px;
        margin-top: 20px;
        background-color: #003d47;
        border: 1px solid #547895;
        width: 100%;
        padding: 6px;
        color: #fff;
        font-size: 15px;
        margin: 30px 0;
    }
`;
